// @flow
import connectWebActions from 'fg-frontend/src/webComponents/connectWebActions';
import { connectWebComponents } from 'fg-frontend/src/webComponents/decorate';
import autoTitleLinksWithBlankTarget from 'fg-frontend/src/components/autoTitleLinksWithBlankTarget';
import safeBlankLinks from 'fg-frontend/src/components/safeBlankLinks';
// import cookiesPolicy from 'fg-frontend/components/CookiesPolicy/index';
import cookiesPolicy from './components/CookiesPolicy/index';
// import phoneLink from 'fg-frontend/components/PhoneLink';

import configureWebComponents from './configureWebComponents';
import configureWebActions from './configureWebActions';

import 'fg-frontend/ramjet/liveValidation';
// import 'bootstrap/collapse'; TODO - use this path if using BS4 bootstrap/js/dist/collapse

cookiesPolicy({
  imgSrc: '/img/cookie-policy/cookie.png',
  disableRwdImg: false,
  enableTechnicalButton: true,
  messages: {
    en: {
      perex: 'This website uses cookies to provide social media functions and analyse the visit rate. By clicking on the "Enable all cookies" button, you agree to storage and use of cookies. Detailed information about cookies <a class="cookies-policy__link" href="/en/information-about-cookies">see here</a>.',
    },
  },
  settingsMessages: {
    en: {
      perex: 'You can set which cookies will be processed here. For more information, please go to <a class="cookies-settings__link" href="/en/information-about-cookies">Cookie information</a>',
    },
  },
});
connectWebComponents(configureWebComponents);
connectWebActions(configureWebActions, ['keyup']);
autoTitleLinksWithBlankTarget();
// phoneLink();

// Nastaveni atributu 'noopener' vsem target="_blank" odkazum, ktere ho nemaji
safeBlankLinks();



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWeb.js